// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Wrapper--1_Kh9"};